import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit(event) {
    const form = event.target.closest('form')
    const formData = new FormData(form)
    const statusText = form.querySelector('.status-text')
    const originalState = !event.target.checked
    
    fetch(form.action, {
      method: form.method,
      headers: {
        'X-CSRF-Token': document.querySelector("[name='csrf-token']").content,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(Object.fromEntries(formData))
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        statusText.textContent = event.target.checked ? 'Active' : 'Pending'
        statusText.classList.toggle('active', event.target.checked)
        this.showNotification('success', 'Status updated successfully')
      } else {
        event.target.checked = originalState
        statusText.textContent = originalState ? 'Active' : 'Pending'
        statusText.classList.toggle('active', originalState)
        this.showNotification('error', data.error || 'Failed to update status')
      }
    })
    .catch(error => {
      event.target.checked = originalState
      statusText.textContent = originalState ? 'Active' : 'Pending'
      statusText.classList.toggle('active', originalState)
      this.showNotification('error', 'An error occurred while updating status')
    })
  }

  showNotification(type, message) {
    const notification = document.createElement('div')
    notification.className = `notification notification-${type}`
    notification.innerHTML = `
      <div class="notification-content">
        <i class="fas ${type === 'success' ? 'fa-check-circle' : 'fa-exclamation-circle'}"></i>
        <span>${message}</span>
      </div>
    `
    document.body.appendChild(notification)
    requestAnimationFrame(() => notification.classList.add('show'))
    
    setTimeout(() => {
      notification.classList.remove('show')
      notification.addEventListener('transitionend', () => notification.remove())
    }, 3000)
  }
}
